import { Message } from './types'

/**
 * @function createStorage - создание хранилища для работы с памятью браузера
 */
export const createStorage = (storageKey: string) => ({
  // загрузка сообщений
  load: (): Message[] => {
    if (typeof window !== 'undefined') {
      const savedMessages = localStorage.getItem(storageKey)
      // console.log('!!! storage.load savedMessages', savedMessages)
      const parsedMessages = savedMessages ? JSON.parse(savedMessages) : []
      // console.log('!!! storage.load parsedMessages', parsedMessages)
      return parsedMessages
    }
    return []
  },

  // сохранение сообщений
  save: (messages: Message[]): void => {
    if (typeof window !== 'undefined') {
      // console.log('!!! storage.save messages', { messages, length: messages?.length })

      // проверяем последнее сообщение на наличие ресторанов
      const lastMessage = messages[messages.length - 1]
      // if (lastMessage && lastMessage.isBot) {
      //   console.log('!!! storage.save lastMessage', {
      //     lastMessage,
      //     restaurants: lastMessage.restaurants,
      //     length: lastMessage.restaurants?.length,
      //   })
      // }

      const serializedMessages = JSON.stringify(messages)
      // console.log('!!! storage.save serializedMessages', serializedMessages)
      localStorage.setItem(storageKey, serializedMessages)
    }
  },

  // удаление сообщений
  remove: (): void => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(storageKey)
    }
  },
})
